/**
 * Builds the payload for patching a scheduled invoice.
 * Matches PatchScheduledFacturaDto on the backend.
 */
export const buildPatchScheduledFacturaPayload = (formState, status) => {
  const config = formState.config || {}

  const dayMap = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
  }

  const payload = {
    dte_type: String(formState.documentType),
    receiver_tax_id: String(formState.client?.tax_id || formState.client?.rut || '').replace(/\./g, ''),
    currency: formState.currency,
    currency_day: formState.currency === 'UF' ? Number(config.currency_day || 1) : undefined,
    amount: Number(formState.amount || 0),
    frequency: config.frequency,
    start_date: config.start_date,
    end_date: config.end_date || null,
    emission_day_adjustment: config.emission_day_adjustment,
    end_type: config.end_type,
    status: status || 'active',
    max_occurrences:
      config.end_type === 'after_occurrences' ? Number(config.max_occurrences) : null,
    day_of_month: ['monthly', 'quarterly', 'semiannual', 'yearly'].includes(config.frequency)
      ? Number(config.day_of_month)
      : null,
    day_of_week:
      config.frequency === 'weekly' ? dayMap[config.day_of_week?.toLowerCase()] || 1 : null,

    // Details
    details: (formState.details || []).map(d => ({
      item_name: String(d.item_name || '').trim(),
      item_description:
        d.showDescription && d.item_description?.trim()
          ? String(d.item_description).trim()
          : undefined,
      quantity: Number(d.quantity) || 0,
      unit_price: Number(d.unit_price) || 0,
      item_code: d.item_code?.trim() ? String(d.item_code).trim() : undefined,
      item_type_code: d.item_type_code?.trim() ? String(d.item_type_code).trim() : undefined
    })),

    // References
    references: (formState.references || [])
      .filter(r => r.dte_type_code || r.reference_folio)
      .map(r => ({
        reference_folio: String(r.reference_folio || '').trim(),
        reference_date: r.reference_date || undefined,
        reference_reason: String(r.reference_reason || '').trim(),
        dte_type_code: String(r.dte_type_code || '')
      }))
  }

  return payload
}
